var resizeWidth;
export function resetStyleFunc() {
    resizeWidth = $('#responsibleCheck').width();

    //フッターリセット
    if (resizeWidth != 2) {
        $('.siteBox').find('a').removeAttr('style');
    }
}